module.exports = __webpack_public_path__ + "media/images/content/velinfo_map-8764297e5fff61fd8d3b8a39530558fd.png";